import messages from "./merge-alert-messages";

export default {
  PUAM_103: messages.organizationMismatch,
  PUAM_104: messages.hasAssignedRole,
  PUAM_106: messages.hasHolds,
  PUAM_200: messages.hasCheckouts,
  PUAM_201: messages.hasEducationCredits,
  PUAM_401: messages.expiredSession,
  PUAM_405: messages.sameAccount
};
